import React from 'react'
import styled from 'styled-components'
import ArrowImg from '../../images/orange_arrow_right.svg'

const ArrowIMG = styled.img`
    margin-bottom: 10px;
`

const SPAN = styled.span`
    font-size: 40px;
    margin-left: 40px;
`

const Wrapper = styled.div`
    text-align: center;
    margin-bottom: 8vh;
`

const ArrowedTitle = ({text}) => {
    return (
        <Wrapper>
            <ArrowIMG src={ArrowImg} />
            <SPAN>{text}</SPAN>
        </Wrapper>
    )
}

export default ArrowedTitle
